// EmployeeFields.js

export const EmployeeListFields = [
    { key: 'actions', label: 'Actions' },
    { key: 'id', label: 'ID' },
    { key: 'employeeName', label: 'Name'},
    { key: 'position', label: 'Position' },
    { key: 'phone', label: 'Phone Number' },
    { key: 'email', label: 'Email' },
    { key: 'state', label: 'State' },
    { key: 'city', label: 'City' },
    { key: 'role', label: 'Role' }
];

// Define the options for select fields
export const DepartmentOptions = [
    { key: 'modernization', label: 'Modernization' },
    { key: 'sales', label: 'Sales' },
    { key: 'engineering', label: 'Engineering' },
    // Add more departments as needed
];

export const TypeOptions = [
    { key: 'helperModernization', label: 'Helper - Modernization' },
    { key: 'manager', label: 'Manager' },
    { key: 'technician', label: 'Technician' },
    // Add more types as needed
];

export const StatusOptions = [
    { key: 'active', label: 'Active' },
    { key: 'inactive', label: 'Inactive' },
    // Add more statuses if needed
];

export const RoleOptions = [
    // { key: 'POWER_USER', label: 'Power User' },
    { key: 'ADMIN', label: 'Admin' },
    // { key: 'DISPATCHER', label: 'Dispatcher' },
    // Add more roles as needed
];

// Create a lookup for options to display labels
export const OptionLookup = {
    department: DepartmentOptions.reduce((acc, { key, label }) => ({ ...acc, [key]: label }), {}),
    type: TypeOptions.reduce((acc, { key, label }) => ({ ...acc, [key]: label }), {}),
    status: StatusOptions.reduce((acc, { key, label }) => ({ ...acc, [key]: label }), {}),
    role: RoleOptions.reduce((acc, { key, label }) => ({ ...acc, [key]: label }), {}),
};

// Define all form fields with their properties and group them
export const FieldsList = [
    {
        id: 'personalInfo',
        title: 'Personal Information',
        fields: [
            { key: 'firstName', label: 'First Name', type: 'text', required: true },
            { key: 'lastName', label: 'Last Name', type: 'text', required: true },
            { key: 'reference', label: 'Reference', type: 'text' },
        ],
    },
    {
        id: 'accountInfo',
        title: 'Account Information',
        fields: [
            { key: 'role', label: 'Role', type: 'select', required: true, options: RoleOptions },
            { key: 'status', label: 'Status', type: 'select', options: StatusOptions },
        ],
    },
    {
        id: 'usernameInfo',
        title: 'Username Information',
        fields: [
        { key: 'username', label: 'Username', type: 'text', required: true },
        ],
    },
    {
        id: 'passwordInfo',
        title: 'Password Information',
        fields: [
            { key: 'password', label: 'Password', type: 'password', required: true },
        ],
    },
    {
        id: 'addressInfo',
        title: 'Address Information',
        fields: [
            { key: 'address', label: 'Address', type: 'text' },
            { key: 'city', label: 'City', type: 'text' },
            { key: 'state', label: 'State', type: 'text' },
            { key: 'zip', label: 'Zip', type: 'text' },
        ],
    },
    {
        id: 'datesInfo',
        title: 'Dates and Miscellaneous Information',
        fields: [
            { key: 'startDate', label: 'Start Date', type: 'date' },
            { key: 'endDate', label: 'End Date', type: 'date' },
            { key: 'hiredDate', label: 'Hired Date', type: 'date' },
            { key: 'nextReview', label: 'Next Review', type: 'date' },
        ],
    },
    {
        id: 'contactInfo',
        title: 'Contact Information',
        fields: [
            { key: 'phone', label: 'Primary Phone', type: 'text', prefix: '+1' },
            { key: 'cellPhone', label: 'Cell Phone', type: 'text' },
            { key: 'otherPhone', label: 'Other Phone', type: 'text' },
            { key: 'email', label: 'Email Address', type: 'email', required: true },
        ],
    },
    {
        id: 'jobInfo',
        title: 'Job Information',
        fields: [
            { key: 'manager', label: 'Manager', type: 'text' },
            { key: 'department', label: 'Department', type: 'select', options: DepartmentOptions },
            { key: 'title', label: 'Title', type: 'text' },
            { key: 'position', label: 'Position', type: 'text' },
        ],
    },
];
